import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import TYPES from '../../../config/Types'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import { IStatement } from '../../../model/statement'
import { Meta } from '../../../model/meta'

export default async function fetchConsiders(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.getIsConsidered(statement).then((isConsidered: Meta<boolean>) => {
        statementStore.commitSetIsConsidered({ statement: statement, isConsidered: isConsidered.value })
    })

    return
}
